import BackToTop from "./components/layout/BackToTop";
import Footer from "./components/layout/Footer";
import Navbar from "./components/layout/Navbar";
import About from "./components/sections/About";
import ContactMap from "./components/sections/ContactMap";
import Hero from "./components/sections/Hero";
import JoinTeaser from "./components/sections/JoinTeaser";
import JoinUs from "./components/sections/JoinUs";
import Reservation from "./components/sections/Reservation";
import Services from "./components/sections/Services";

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <JoinTeaser />
        <Reservation />
        <JoinUs />
        <ContactMap />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default App;
